export const CREDIT_RATING_MAX = 850;
